module.exports = __webpack_public_path__ + "img/30_38.72350290.png";